export default (state = null, action) => {
  let { type, payload } = action
  switch (type) {
    case 'FETCH_ASSIGNED_SUBSCRIPTION':
      return payload
    case 'LOGOUT':
      return null
    default:
      return state
  }
}
